import { useLocale } from 'next-intl';

export type TranslatableItem = {
  translation?: Record<string, any> | null;
  [key: string]: any;
};

export const useTranslatedData = <T extends TranslatableItem>(
  data: T[] | undefined,
  fields: string[]
): T[] => {
  const locale = useLocale();

  return (
    data?.map(item => {
      const newData = { ...item };

      fields.forEach(field => {
        if (locale === 'uz' && item?.translation?.[field]) {
          (newData[field] as any) = item.translation[field];
        }
      });

      return newData;
    }) || []
  );
};

export const useTranslatedDataWithNode = <T extends TranslatableItem>(
  data: T[] | undefined,
  fields: string[]
): T[] => {
  const locale = useLocale();

  return (
    data?.map(item => {
      const newData = { ...item };

      if (item.node) {
        const newNode = { ...item.node };

        fields.forEach(field => {
          if (locale === 'uz' && item.node.translation?.[field]) {
            newNode[field] = item.node.translation[field];
          }
        });

        (newData as any).node = newNode;
      }

      return newData;
    }) || []
  );
};

export type NestedTranslatableItem = {
  [key: string]: any;
  category?: any;
  brand?: any;
  variant?: any;
};

export const useNestedTranslatedData = <T extends NestedTranslatableItem>(
  data: T[] | undefined,
  fields: string[],
  nestedFields: string[]
): T[] => {
  const locale = useLocale();

  return (
    data?.map(item => {
      const newData = { ...item };

      fields?.forEach(field => {
        if (locale === 'uz' && item?.translation?.[field]) {
          (newData[field] as any) = item.translation[field];
        }
      });

      nestedFields?.forEach(nestedField => {
        if (locale === 'uz' && item[nestedField]?.translation) {
          (newData[nestedField] as any) = {
            ...item[nestedField],
            name: item[nestedField].translation.name,
          };
        }
      });

      return newData;
    }) || []
  );
};
